<!-- ----------------------------------------------- -->
<template>
  <v-card light class="com-popup vg-content">
    <v-row class="com-popup-header">
      <span class="com-popup-title">{{ text.vGTitle }}</span>
      <v-spacer></v-spacer>
      <v-btn icon x-small @click="closeViewGroup">
        <v-icon color="white">highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-container class="pl-6 pr-6 pt-0 pb-0">
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.mapType }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <v-select
            v-model="map"
            required
            :items="mapList"
            class="pt-0 mt-0"
            item-color="success"
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.groupLabel }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <v-select
            v-model="group"
            required
            :items="groupList"
            class="pt-0 mt-0"
            menu-props="auto"
            item-color="success"
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.radarLabel }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <v-switch
            v-model="isRadar"
            inset
            :label="isRadar ? text.show : text.hide"
            color="success"
            class="mt-0 pt-0 pb-0"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.warnLabel }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <!-- 表示観測所で個別設定以外を選択したときにトグルを表示-->
          <v-switch
            v-if="!(viewGroup === 5)"
            v-model="isWarn"
            inset
            :label="isWarn ? text.show : text.hide"
            color="success"
            class="mt-0 pt-0 pb-0"
            hide-details
          ></v-switch>
          <span v-else class="mt-0 pt-0 pb-0"> {{ text.guideDispCustom }} </span>
        </v-col>
      </v-row>
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.riverLabel }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <v-switch
            v-model="isRiver"
            inset
            :label="isRiver ? text.show : text.hide"
            color="success"
            class="mt-0 pt-0 pb-0"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row align="center" class="pt-3 pb-3">
        <v-col cols="4" class="pt-0 pb-0">
          <span class="success--text">{{ text.registPoint }}</span>
        </v-col>
        <v-col cols="8" class="pt-0 pb-0">
          <v-switch
            v-model="isPoint"
            inset
            :label="isPoint ? text.show : text.hide"
            color="success"
            class="mt-0 pt-0 pb-0"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 PC用表示グループ設定ダイアログ
 * MapViewGroup.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import WebStorage from "./../../lib/webStorage.js";
export default {
  name: "map-view-group",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        vGTitle: "表示切替",
        show: "表示",
        hide: "非表示",
        groupLabel: "表示観測所",
        radarLabel: "レーダ雨量",
        warnLabel: "発表情報",
        riverLabel: "河川",
        mapType: "地図種別",
        registPoint: "登録地点",
        guideDispCustom: "個別設定から設定してください",
      },
      /** 地図種別選択リスト */
      mapList: ["淡色地図", "淡色地図＋標高地図", "航空写真", "白地図"],
      /** 表示観測所選択リスト */
      groupList: [
        "水位・ダム・河川カメラ",
        "雨量",
        "水質・海岸・積雪深",
        "非表示",
        "登録観測所",
        "個別設定",
      ],
      /** 選択地図 */
      map: "",
      /** 選択グループ */
      group: "",
      /** レーダ雨量表示 */
      isRadar: true,
      /** 河川予警報表示 */
      isWarn: true,
      /** 河川表示 */
      isRiver: true,
      /** 登録地点表示 */
      isPoint: true,
    };
  },
  computed: {
    /** 表示グループ設定ダイアログ表示状態 */
    visibility: {
      get() {
        return this.$store.state.map.showViewGroup;
      },
    },
    /** 表示観測所の選択状態 */
    viewGroup: {
      get() {
        return this.$store.state.map.viewGroup;
      }
    },
  },
  watch: {
    /** 表示グループ設定ダイアログ表示状態監視 */
    visibility() {
      if (this.visibility) {
        // リスト項目がstore未設定の場合は先頭を初期値とする
        this.map = this.$store.state.map.mapType
          ? this.mapList[this.$store.state.map.mapType]
          : this.mapList[0];
        this.group = this.$store.state.map.viewGroup
          ? this.groupList[this.$store.state.map.viewGroup]
          : this.groupList[0];
        this.isRadar = this.$store.state.map.viewRadar;
        this.isWarn = this.$store.state.map.viewRiverWarn;
        this.isRiver = this.$store.state.map.viewRiver;
        this.isPoint = this.$store.state.map.viewPoint;
      }
    },
    /** 地図種別設定 */
    map() {
      this.$store.commit("map/setMapType", this.mapList.indexOf(this.map));
      WebStorage.rewriteDefaultInfo("mapType", this.mapList.indexOf(this.map));
      this.routerMapSetting();
    },
    /** 表示グループ設定 */
    group() {
      this.$store.commit(
        "map/setViewGroup",
        this.groupList.indexOf(this.group)
      );
      WebStorage.rewriteViewGroup(
        this.groupList.indexOf(this.group),
        this.groupList.length
      );
      this.routerMapSetting();
    },
    /** レーダ雨量表示設定 */
    isRadar() {
      this.$store.commit("map/setViewRadar", this.isRadar);
      WebStorage.rewriteDefaultInfo("viewRd", this.isRadar);
      this.routerMapSetting();
    },
    /** 河川予警報表示設定 */
    isWarn() {
      this.$store.commit("map/setViewRiverWarn", this.isWarn);
      WebStorage.rewriteDefaultInfo("viewRw", this.isWarn);
      this.routerMapSetting();
    },
    /** 河川表示設定 */
    isRiver() {
      this.$store.commit("map/setViewRiver", this.isRiver);
      WebStorage.rewriteDefaultInfo("viewRvrln", this.isRiver);
      this.routerMapSetting();
    },
    /** 登録地点表示設定 */
    isPoint() {
      this.$store.commit("map/setViewPoint", this.isPoint);
      WebStorage.rewriteDefaultInfo("viewRp", this.isPoint);
      this.routerMapSetting();
    },
  },
  methods: {
    /** 表示グループ設定ダイアログの非表示 */
    closeViewGroup() {
      this.$store.commit("map/setShowViewGroup", false);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.vg-content {
  position: absolute;
  z-index: 3030;
  bottom: 60px;
  left: 4px;
  width: 400px;
  max-width: calc(100% - 8px);
}
</style>
